import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalDynamicConfigDocument = gql`
  query SalesPortalDynamicConfig(
    $supplierUUID: uuid!
    $businessOrganizationUUID: uuid!
  ) {
    businesses_by_pk(uuid: $supplierUUID) {
      uuid
      supplier_metadata {
        dynamic_config
        po_number_display
        show_order_notes
      }
    }
    employee_chats(
      where: { business_organization_uuid: { _eq: $businessOrganizationUUID } }
    ) {
      chat_uuid
      chat_dynamic_config
      supplier_uuid
    }
  }
`;
export function useSalesPortalDynamicConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalDynamicConfigQuery,
    Types.SalesPortalDynamicConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalDynamicConfigQuery,
    Types.SalesPortalDynamicConfigQueryVariables
  >(SalesPortalDynamicConfigDocument, options);
}
export function useSalesPortalDynamicConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalDynamicConfigQuery,
    Types.SalesPortalDynamicConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalDynamicConfigQuery,
    Types.SalesPortalDynamicConfigQueryVariables
  >(SalesPortalDynamicConfigDocument, options);
}
export type SalesPortalDynamicConfigQueryHookResult = ReturnType<
  typeof useSalesPortalDynamicConfigQuery
>;
export type SalesPortalDynamicConfigLazyQueryHookResult = ReturnType<
  typeof useSalesPortalDynamicConfigLazyQuery
>;
export type SalesPortalDynamicConfigQueryResult = Apollo.QueryResult<
  Types.SalesPortalDynamicConfigQuery,
  Types.SalesPortalDynamicConfigQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalDynamicConfigQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalDynamicConfigQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalDynamicConfigQuery,
    Types.SalesPortalDynamicConfigQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalDynamicConfigQuery,
    Types.SalesPortalDynamicConfigQueryVariables
  >(SalesPortalDynamicConfigDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalDynamicConfigLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalDynamicConfigLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalDynamicConfigQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalDynamicConfigQuery,
    Types.SalesPortalDynamicConfigQueryVariables
  >(SalesPortalDynamicConfigDocument, lazyOptions);
}
